/* tslint:disable */
/* eslint-disable */
/**
 * Authentication Service Api
 * Authentication Service Api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EmployeeStatus,
} from '../models/index';
import {
    EmployeeStatusFromJSON,
    EmployeeStatusToJSON,
} from '../models/index';

/**
 * 
 */
export class EmployeesApi extends runtime.BaseAPI {

    /**
     */
    async getEmployeeStatusesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EmployeeStatus>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/employees`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EmployeeStatusFromJSON));
    }

    /**
     */
    async getEmployeeStatuses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EmployeeStatus>> {
        const response = await this.getEmployeeStatusesRaw(initOverrides);
        return await response.value();
    }

}
